import { getCurrentDate } from "../utils/date";
import { FILTER_BIT_SIZE } from "./filter";

export const DEFAULT_ANALYSIS_START_DATE = "2022-12-01";
export const DEFAULT_ANALYSIS_TO_DATE = getCurrentDate();
export const DEFAULT_ANALYSIS_TIME = "0-23";
export const DEFAULT_ANALYSIS_FILTER = "1".repeat(FILTER_BIT_SIZE);
